'use strict'

/**
 * Composant Adresse pour le panier
 */

import { GeocodeService } from 'Modules/Services/geocodeService'

const urlAPP = window.location.origin

export default Vue.component('adresse', {
    props: ['client', 'countryCodes'],
    data: function () {
        return {
            showFormulaireAdresse: false,
            adresses: null,
            rechercheAdresse: '',
            showFormulaireAdresseManuelle: false,
            villes: null,
            form: {
                nom: { isValid: true },
                prenom: { isValid: true },
                adresse: { isValid: true },
                codepostal: { isValid: true },
                ville: { isValid: true },
                pays: { isValid: true },
                telephone: { isValid: true }
            },
            geocodeService: null
        }
    },
    computed: {
        Pays() {
            var pays = this.client.Pays.find((x) => x.IsSelected)

            return pays
        }
    },
    async mounted() {
        if (!this.client) {
            return
        }

        this.geocodeService = new GeocodeService(this.countryCodes)

        this.villes = await this.GetVilles(this.client.CodePostal)

        this.rechercheAdresse =
            this.client.Adresse +
            ', ' +
            this.client.CodePostal +
            ', ' +
            this.client.Ville

        this.form.telephone.isValid = this.client.HasTelephoneValide

        if (this.client.HasAdresseValide) {
            return
        }

        this.form.adresse.isValid = this.IsValid(
            this.client.Adresse,
            this.form.adresse
        )

        this.form.codepostal.isValid = this.IsValid(
            this.client.CodePostal,
            this.form.codepostal
        )

        this.form.ville.isValid = this.IsValid(
            this.client.Ville,
            this.form.ville
        )

        this.DisplayAdresseManuel()
    },
    methods: {
        //affichage du formulaire de changement d'adresse
        DisplayChangeAdresse() {
            this.showFormulaireAdresse = true
            this.$emit('display-change-adresse')
        },
        async RechercherAdresse() {
            if (this.rechercheAdresse.length > 3) {
                var result = await this.geocodeService.RechercheAdresse(
                    this.rechercheAdresse
                )

                if (result && result.suggestions) {
                    this.adresses = result.suggestions
                }
            }
        },
        async ChoisirAdresse(magicKey) {
            this.adresses = null

            if (magicKey != '') {
                var result = await this.geocodeService.RechercheKey(magicKey)

                if (result && result.candidates) {
                    var infos = result.candidates[0]
                    this.rechercheAdresse = infos.address
                    this.client.Adresse = infos.attributes.StAddr
                    this.client.CodePostal = infos.attributes.Postal

                    const paysOld = this.client.Pays.find((x) => x.IsSelected)
                    paysOld.IsSelected = false

                    const pays = this.client.Pays.find(
                        (x) => x.CodePaysTrigramme == infos.attributes.Country
                    )
                    pays.IsSelected = true

                    this.villes = await this.GetVilles(this.client.CodePostal)

                    if (this.villes.length == 0) {
                        this.client.Ville = ''
                        this.showFormulaireAdresseManuelle = true
                        return
                    }

                    let ville = this.villes.find(
                        (x) =>
                            x.NomVilleReel.toUpperCase() ==
                            infos.attributes.City.toUpperCase()
                    )

                    if (!ville) {
                        if (this.villes.length == 1) {
                            ville = this.villes[0]
                            this.client.Ville = ville.NomVilleReel
                        } else {
                            this.client.Ville = ''
                        }

                        this.showFormulaireAdresseManuelle = true
                        return
                    }

                    this.client.Ville = ville.NomVilleReel
                }
            }
        },
        async UpdateCodePostal() {
            this.villes = await this.GetVilles(this.client.CodePostal)
        },
        DisplayAdresseManuel() {
            this.showFormulaireAdresseManuelle = true
        },
        SetPays(event) {
            const value = event.target.value

            const paysOld = this.client.Pays.find((x) => x.IsSelected)
            paysOld.IsSelected = false

            const pays = this.client.Pays.find((x) => x.Libelle == value)
            pays.IsSelected = true
        },
        async GetVilles(codepostal) {
            const parametres = {
                cp: codepostal
            }

            const requestOptions = {
                method: 'POST',
                body: JSON.stringify(parametres),
                headers: {
                    'Content-Type': 'application/json'
                }
            }

            var response = await fetch(
                urlAPP + '/Inscription/GetListOfVilleByCodePostal',
                requestOptions
            )
            var returnValue = await response.json()

            return returnValue.ListVilles
        },
        IsValidTel() {
            const pays = this.client.Pays.find((x) => x.IsSelected)
            const regex = new RegExp(pays.RegexTelephone)

            var tel = this.client.Telephone

            if (pays) {
                if (
                    pays.CodePays == 'FR' &&
                    this.client.Telephone.length == 10 &&
                    this.client.Telephone.substring(0, 1) == '0'
                ) {
                    tel = this.client.Telephone.substring(1, 10)
                }

                if (tel.substring(0, 1) != '+') {
                    tel = '+' + pays.IndicatifTelephone + tel
                }

                this.client.Telephone = tel

                var test = regex.test(tel)
                this.form.telephone.isValid = test

                return test
            }
        },
        IsValid(input, form) {
            var returnValue = false

            if (input == '' || input == undefined || input == null) {
                returnValue = false
            } else {
                returnValue = true
            }

            form.isValid = returnValue

            return returnValue
        },
        submit() {
            let valid = true

            valid &= this.IsValid(this.client.Nom, this.form.nom)
            valid &= this.IsValid(this.client.Prenom, this.form.prenom)
            valid &= this.IsValid(this.client.Adresse, this.form.adresse)
            valid &= this.IsValid(this.client.CodePostal, this.form.codepostal)
            valid &= this.IsValid(this.client.Ville, this.form.ville)

            const pays = this.client.Pays.find((x) => x.IsSelected)
            valid &= this.IsValid(pays, this.form.pays)

            valid &= this.IsValidTel()

            if (valid) {
                this.$emit('validate')
                this.showFormulaireAdresse = false
            }

            return false
        }
    }
})
